import { render, staticRenderFns } from "./obj_print.vue?vue&type=template&id=190067dd&"
import script from "./obj_print.vue?vue&type=script&lang=js&"
export * from "./obj_print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports